import axiosClient from "../../../../../../api/axiosClient";

export async function fetchInventoryValuation(filters = {}) {

  const params = {
    material: filters.material || undefined,
    batch: filters.batch || undefined
  };

  const res = await axiosClient.get(
    "/api/ppe/material-flow/inventory/reports/inventory-valuation",
    { params }
  );

  return res.data.data;
}

export async function exportInventoryValuationExcel(filters = {}) {

  const params = {
    material: filters.material || undefined,
    batch: filters.batch || undefined
  };

  const response = await axiosClient.get(
    "/api/ppe/material-flow/inventory/reports/inventory-valuation/excel",
    {
      params,
      responseType: "blob"
    }
  );

  return response.data;
}